module.exports = __webpack_public_path__ + "static/img/guess_word_photo.ca4d7d1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/guess_word/guess_word_photo.png
// module id = XCDQ
// module chunks = 1